export default [{"url":"https://graceop-0.api.invexerp.io","name":"Branch 1","port":"5045","isStore":true,"isHQ":true}]